<template>
  <transition name="modal-fade">
    <div id="modalEditBanner" class="dibble-modal">
      <div class="modal small-m">
        <div
          class="modal-dialog modal-form "
          role="document"
          style="width: 600px"
        >
          <div class="modal-content" style="min-width: 600px !important;">
            <div class="modal-header">
              <p class="title-modal">Donation Details</p>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                @click="closeModal"
              >
              <img src="@/assets/images/close-dialog.svg" alt="close-icon">
              </button>
            </div>
            <div class="modal-body form-box mt-2" v-if="donation">
              <div class="user-modal-content" style="overflow-x: hidden">
                <div class="row mt-2 pl-2 pr-2">
                  <div class="col-md-12">
                      <TextField
                          v-model="donation.campaign_title"
                          name="campaign_title"
                          label="Campaign Name"
                          disabled
                      />
                  </div>
                  <div class="col-md-12">
                      <TextField
                          v-model="donation.designation_name"
                          name="designation_name"
                          label="Designation"
                          disabled
                      />
                  </div>
                  <div class="col-md-12">
                      <TextField
                          v-model="donation.full_name"
                          name="full_name"
                          label="Full Name"
                          disabled
                      />
                  </div>
                  <div class="col-md-12">
                      <TextField
                          v-model="donation.phone"
                          name="phone"
                          label="Phone"
                          disabled
                      />
                  </div>
                  <div class="col-md-12">
                      <TextField
                            v-model="donation.email"
                            name="email"
                            label="Email"
                            disabled
                      />
                  </div>
                  <div class="col-md-12">
                      <TextField
                            v-model="donation.added_on"
                            name="added_on"
                            label="Date"
                            disabled
                      />
                  </div>
                  <div class="col-md-12">
                      <TextField
                            v-model="donation.amount"
                            name="amount"
                            label="Amount"
                            disabled
                      />
                  </div>
                    <div class="col-md-12">
                        <div class="list-checbox donation-checkbox">
                            <div class="checkbox-item pl-5 pr-5">
                                <label class="checkbox-custom position-relative">
                                    <input v-if="donation.is_anonymous" type="checkbox" disabled :checked="true">
                                    <input v-else type="checkbox" :checked="false" disabled>
                                    <span class="checkmark-new" :class="{'not-active': !donation.is_anonymous}"></span>
                                </label>
                                <p :class="{'active': donation.is_anonymous}">Requested to remain anonymous</p>

                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <TextareaField
                            v-model="donation.note"
                            name="note"
                            label="Note"
                            disabled
                            rows="5"
                            classWrapper="mb-4"
                        />
                    </div>
                </div>
              </div>
              <div>
                <div class="d-flex justify-content-center mt-2">
                  <button v-text="'Close'"
                          class="btn-dialog btn-sm ok-btn" @click="closeModal">
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import TextField from '@/commons/FormElements/TextField.vue';
import TextareaField from "@/commons/FormElements/TextareaField.vue";

export default {
  name: "ModalDonationDetails",
    components: {TextareaField, TextField},
	props: {
		data: Object
	},
  data() {
    return {
        donation: null
    };
  },
  created() {
    this.donation = this.data
  },
  watch: {
    userData() {
      this.mapFields.forEach(field => {
        this.form[field] = this.userData[field];
      });
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },

  },
};
</script>

<style lang="scss" scoped>
	.modal-content {
		min-width: 500px !important;
	}
	.modal-content, .modal-body {
		background: #EDF5F7 !important;
		border-radius: 60px !important;
		padding: 10px 20px;
	}
	.modal-header {
		display: flex !important;
		justify-content: space-between !important;
		align-items: center;
		padding: 10px 0px !important;
		border-bottom: 1.5px solid #1C5169;
		margin: 0 20px !important;
		.title-modal {
			font-family: 'Open Sans';
			font-style: normal;
			font-weight: 700;
			font-size: 22px;
			line-height: 22px;
			letter-spacing: 0.01em;
			color: #1C5169;
			margin-top: 0 !important;
		}
		button {
			border: none !important;
			outline: none !important;
			background: initial;
		}
	}
  .user-modal-content {
    max-height: 500px;
    overflow: scroll;
  }
  .btn-dialog.btn-sm {
    font-size: 14px;
    height: 40px;
  }
  .donation-checkbox {
      .checkbox-item {
          display: flex;
      }
      .checkbox-custom {
          position: inherit;
          width: 40px;
          height: 40px;

          .checkmark-new {
              border-radius: 5px;
              background: #41B8DC;

              &.not-active {
                  background: #dde6e9;
              }
          }
      }

      p {
          color: #555E67;
      }
  }
</style>
